import React from 'react';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    /** Dark variant, see MessagesPage. */
    videoDark?: boolean;
}

const UnreadDivider = ({ videoDark = false }: Props) => {
    const { i18next } = useAppContext();

    return (
        // Sticky for the same reason as the date pill, and on the same terms:
        // see DateDivider.
        <div
            data-test-id="message-unread-banner"
            className="sticky -top-6 z-10 w-full"
        >
            {/* The same three-quarters the date pill uses, so this lays no
                more white over the messages than that one does.

                It leaves a case uncovered, knowingly: this banner can pin at
                the same offset as its own day's header, and in the last
                quarter a date label wider than "New messages" would show its
                ends around this pill. Masking that needs full height, which
                covers the text either side, or a patch across the middle,
                which punches a white block through a long message. Both look
                worse than the case they avoid, which needs a long date label
                and unread messages under it in a day tall enough to scroll
                inside. */}
            <div
                className={twMerge(
                    'absolute h-3/4 w-full',
                    videoDark ? 'bg-gray-800' : 'bg-white',
                )}
            />
            <div className="relative w-full px-4 pt-6">
                <div className="relative w-full">
                    <div className="bg-red absolute start-0 top-1/2 z-0 h-[1px] w-full" />
                    <div className="flex w-full justify-center">
                        <div
                            className={twMerge(
                                'border-red relative flex h-6 items-center rounded-sm border px-3 py-0.5',
                                videoDark ? 'bg-gray-800' : 'bg-white',
                            )}
                        >
                            <span className="text-red text-xs font-bold">
                                {i18next.t('chat.flowfeed.new_messages')}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(UnreadDivider);
